<template>
    <div style="  background: #eeeeee;height: 100vh;">
        <div class="wrap">
            <div class="walletTop">
                <van-icon name="arrow-left" color="#fff" size="25" @click="$router.go(-1)" />
                <div class="topTitle">
                    <div>
                        总单量
                    </div>
                </div>
                <div class="topNum">
                    <div>
                        {{sellData.order_number}}
                    </div>
                    <div>
                        总单量
                    </div>
                </div>
            </div>
            <!-- 列表 -->
            <div class="recordList" v-if='sellData.data.length>0'>
                <div class="recordItem" v-for="(item,index) in sellData.data" :key="index">
                    <div class="itemMoney">
                        <span>{{item.phone.replace( /^(\d{3})\d{4}(\d{4})$/,"$1****$2")}}</span>
                    </div>
                    <div class="itemMoney"> <span>{{item.group_order_all_number}}</span>单</div>
                </div>
            </div>
            <div v-else class="noData">
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { saleOrderList } from "@/api/personal";
    export default {
        data() {
            return {
                sellData: {
                    data: [],
                    order_number: 0
                }
            };
        },
        created() {
            saleOrderList().then(res => {
                this.sellData = res;
            })
        },
        methods: {
        }
    };
</script>
<style lang='less' scoped>
    .wrap {
        height: 100%;
        background: #eeeeee;

        .walletTop {
            width: 100%;
            height: 254.5px;
            background:url('../../assets/imgs/personal/bg.png') 0  0 no-repeat;
            background-size:100% 100%;
            color: #FEFEFE;
            font-size: 18px;
            padding-top: 14.5px;
            box-sizing: border-box;

            .topTitle {
                display: flex;
                margin-bottom: 26.5px;

                div {
                    &:first-child {
                        background: #4FB7FE;
                        font-size: 15px;
                        border-radius: 0px 13.25px 13.25px 0px;
                        margin-right: 9px;
                        height: 26.5px;
                        line-height: 26.5px;
                        width: 50px;
                    }

                }
            }

            .topNum {
                text-align: center;

                div {
                    &:first-child {
                        margin-bottom: 23.5px;
                        font-size: 53px;
                    }
                }
            }
        }

        .recordList {
            width: 345px;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            padding: 0 13px;
            margin: 10px auto 0;

            .recordItem {
                display: flex;
                justify-content: space-between;
                color: #666666;
                padding: 14.5px 0 12.5px;
                border-bottom: 1px solid #c1c1c1;
                font-size: 13px;
            }
        }
    }
</style>